import React, { FC } from 'react';
import useTranslation from '../../../hooks/useTranslation';
import CustomSelect from '../../../common/CustomSelect';
import Text from '@ingka/text';
import { Controller, useFormContext } from 'react-hook-form';
import { AD, roleRestricted, SA } from '../../RoleRestricted/utils';
import { useTypedSelector } from '../../../store';
import { selectUserRole } from '../../../store/userData/selectors';
const ProjectConfidentialButton: FC = () => {
  const t = useTranslation();
  const { control } = useFormContext();
  const role = useTypedSelector(selectUserRole);

  const confidentialityOptions = {
    INTERNAL: t('confidentialityLevels.INTERNAL'),
    CONFIDENTIAL: t('confidentialityLevels.CONFIDENTIAL'),
    STRICTLY_CONFIDENTIAL: t('confidentialityLevels.STRICTLY_CONFIDENTIAL'),
  };

  const getConfidentialityOptions = (role: string) => {
    const isRestricted = roleRestricted([AD, SA], role);

    if (isRestricted) {
      return confidentialityOptions;
    }

    const { INTERNAL } = confidentialityOptions;
    return { INTERNAL };
  };

  return (
    <>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.Confidentiality')}
      </Text>
      <span
        style={{ fontWeight: '400' }}
        className={'form-field__character-limit form-field__message'}
      >
        {t('message.confidentialProject')}
      </span>
      <Controller
        name={'confidential'}
        control={control}
        render={({ field }) => (
          <CustomSelect
            {...field}
            nullable={false}
            dataTestID={'confidential-select'}
            optionsArray={getConfidentialityOptions(role)}
            label={t('labels.Confidentiality')}
            defaultValue={'INTERNAL'}
          />
        )}
      />
    </>
  );
};

export default ProjectConfidentialButton;
